import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { LVN_COMPETENCY_ITEMS } from './lvnConstants';

const LvnCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="LVN"
            title="LVN CLINICAL COMPETENCY ASSESSMENT"
            items={LVN_COMPETENCY_ITEMS}
            totalPages={9}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default LvnCompetency;
